var map = {
	"./another-movie-db/cardImgs/bg.webp": 5230,
	"./another-movie-db/cardImgs/logo.svg": 9792,
	"./another-movie-db/screenshots/ss-0.webp": 8721,
	"./another-movie-db/screenshots/ss-1.webp": 2964,
	"./another-movie-db/screenshots/ss-2.webp": 2961,
	"./another-movie-db/screenshots/ss-3.webp": 1703,
	"./another-movie-db/screenshots/ss-4.webp": 4951,
	"./another-movie-db/screenshots/ss-5.webp": 193,
	"./data-services/cardImgs/bg.jpg": 7802,
	"./data-services/cardImgs/logo.svg": 4553,
	"./data-services/screenshots/ds-0.webm": 8681,
	"./data-services/screenshots/ds-1.webp": 2795,
	"./data-services/screenshots/ds-2.webp": 8926,
	"./data-services/screenshots/ds-3.webp": 8067,
	"./esports-news-api/cardImgs/bg.svg": 5683,
	"./esports-news-api/cardImgs/logo.svg": 6438,
	"./fidelity-1/cardImgs/bg.webp": 4603,
	"./fidelity-1/cardImgs/logo.svg": 9459,
	"./fidelity-2/cardImgs/bg.webp": 7050,
	"./fidelity-2/cardImgs/logo.svg": 6907,
	"./hump-day-golf-league/cardImgs/bg.webp": 2641,
	"./hump-day-golf-league/cardImgs/logo.svg": 1129,
	"./hump-day-golf-league/screenshots/ss-0.webm": 9882,
	"./hump-day-golf-league/screenshots/ss-1.webp": 3361,
	"./hump-day-golf-league/screenshots/ss-2.webp": 9619,
	"./kyk-share-improvements/cardImgs/bg.png": 2199,
	"./kyk-share-improvements/cardImgs/logo.svg": 1599,
	"./kyk-share-improvements/screenshots/ks-0.webm": 8393,
	"./kyk-share-improvements/screenshots/ks-1.webm": 8686,
	"./kyk-share-improvements/screenshots/ks-2.webm": 3836,
	"./kyk-share-improvements/screenshots/ks-3.webp": 5458,
	"./kyk-share-improvements/screenshots/ks-4.webp": 4024,
	"./kyk-share-improvements/screenshots/ks-5.webp": 3682,
	"./pokeapi-app/cardImgs/bg.webp": 1742,
	"./pokeapi-app/cardImgs/logo.svg": 3286,
	"./pokeapi-app/screenshots/ss-1.webp": 6742,
	"./pokeapi-app/screenshots/ss-2.webp": 8209,
	"./pokeapi-app/screenshots/ss-3.webp": 7509,
	"./roche-bros-redesign/cardImgs/bg.webp": 9509,
	"./roche-bros-redesign/cardImgs/logo.svg": 2190,
	"./roche-bros-redesign/screenshots/ss-0.webm": 2437,
	"./roche-bros-redesign/screenshots/ss-1.webp": 3404,
	"./roche-bros-redesign/screenshots/ss-2.webp": 1343,
	"./roche-bros-redesign/screenshots/ss-3.webp": 1670,
	"./snapface/cardImgs/bg.webp": 9829,
	"./snapface/cardImgs/logo.svg": 8422,
	"./snapface/screenshots/ss (0).webp": 8902,
	"./snapface/screenshots/ss (1).webp": 7611,
	"./snapface/screenshots/ss (2).webp": 9942,
	"./snapface/screenshots/ss (4).webp": 6491,
	"./snapface/screenshots/ss (5).webp": 5884,
	"./streamlit-craigslist-used-cars/cardImgs/bg.webp": 536,
	"./streamlit-craigslist-used-cars/cardImgs/logo.svg": 4118,
	"./streamlit-craigslist-used-cars/screenshots/ss-0.webm": 6185,
	"./streamlit-craigslist-used-cars/screenshots/ss-1.webp": 3344,
	"./streamlit-craigslist-used-cars/screenshots/ss-2.webp": 7904,
	"./streamlit-craigslist-used-cars/screenshots/ss-3.webp": 757,
	"./todoist-notion-sync/cardImgs/bg.png": 5046,
	"./todoist-notion-sync/cardImgs/logo.svg": 8133
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4039;